/* One track keeps both lines in phase. CSS reverses from the current position. */
(() => {
  'use strict';
  const selector = '.button,.hero-link';
  function enhance(button) {
    if (button.closest('[data-no-button-motion]')) return;
    button.querySelectorAll('.button-roll').forEach(wrap => {
      const track = wrap.querySelector('.button-roll-track');
      if (!track || track.children.length !== 2) wrap.replaceWith(document.createTextNode(wrap.textContent));
      else if (track.lastElementChild.textContent !== track.firstElementChild.textContent) track.lastElementChild.textContent = track.firstElementChild.textContent;
    });
    const walk = document.createTreeWalker(button, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.textContent.trim() && !node.parentElement.closest('svg,.button-roll,.sr-only,[aria-hidden="true"]') ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    const nodes = [];
    while (walk.nextNode()) nodes.push(walk.currentNode);
    nodes.forEach(node => {
      const wrap = document.createElement('span'); wrap.className = 'button-roll';
      const track = document.createElement('span'); track.className = 'button-roll-track';
      const first = document.createElement('span'); first.className = 'button-roll-line'; first.textContent = node.textContent;
      const second = first.cloneNode(true); second.setAttribute('aria-hidden', 'true');
      track.append(first, second); wrap.append(track); node.replaceWith(wrap);
    });
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches?.(selector)) enhance(root);
    root.querySelectorAll(selector).forEach(enhance);
  }
  const observer = new MutationObserver(records => {
    observer.disconnect();
    const buttons = new Set();
    records.forEach(record => {
      const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      const button = element?.closest(selector);
      if (button) buttons.add(button);
      record.addedNodes.forEach(node => { if (node.nodeType === 1 && !node.closest('.button-roll')) scan(node); });
    });
    buttons.forEach(enhance);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  });
  scan(document);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
